/* ----------------------------------------------------------------------------------------------------
*  top swiper
* --------------------------------------------------------------------------------------------------*/
if (document.getElementById('top') != null) {
    const topSwiper = new Swiper('.pickup-swiper', {
        navigation: {
            nextEl: ".pickup-swiper-button-next",
            prevEl: ".pickup-swiper-button-prev",
        },

        pagination: {
            el: '.pickup-swiper-pagination',
            type: "bullets",
            clickable: "clickable"
        },

        loop: true,
        spaceBetween: 0,
        speed: 600,

        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: false,
        },

    });

    const lineUpSwiper01 = new Swiper('.line-up-swiper01', {
        navigation: {
            nextEl: ".line-up-swiper-button-next01",
            prevEl: ".line-up-swiper-button-prev01",
        },

        pagination: {
            el: '.line-up-swiper-pagination01',
            type: "bullets",
            clickable: "clickable"
        },

        loop: true,
        spaceBetween: 40,
        speed: 600,
        initialSlide: 1,

        breakpoints: {
            992: {
                slidesPerView: 3,
                centeredSlides: true,
            }
        },

        slidesPerView: 1,

        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: false,
        },

    });

    const lineUpSwiper02 = new Swiper('.line-up-swiper02', {
        navigation: {
            nextEl: ".line-up-swiper-button-next02",
            prevEl: ".line-up-swiper-button-prev02",
        },

        pagination: {
            el: '.line-up-swiper-pagination02',
            type: "bullets",
            clickable: "clickable"
        },

        loop: true,
        spaceBetween: 40,
        speed: 600,
        initialSlide: 1,

        breakpoints: {
            992: {
                slidesPerView: 3,
                centeredSlides: true,
            }
        },

        slidesPerView: 1,

        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: false,
        },

    });

    const lineUpSwiper03 = new Swiper('.line-up-swiper03', {
        navigation: {
            nextEl: ".line-up-swiper-button-next03",
            prevEl: ".line-up-swiper-button-prev03",
        },

        pagination: {
            el: '.line-up-swiper-pagination03',
            type: "bullets",
            clickable: "clickable"
        },

        loop: true,
        spaceBetween: 40,
        speed: 600,
        initialSlide: 1,

        breakpoints: {
            992: {
                slidesPerView: 3,
                centeredSlides: true,
            }
        },

        slidesPerView: 1,

        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: false,
        },

    });
}
